import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './news-media.styles.scss';

function NewNewsLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() => import('./new-news-hero-component'));
  const ContentComponent = React.lazy(() =>
    import('./news-search/NewsSearchRootComponent')
  );

  return (
    <div className="news news-lp">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>

      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewNewsLandingPage;
